var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:_vm.$style.container},[_c('span',{class:_vm.$style.header},[_vm._v(_vm._s(_vm.$t('checkout.basket.empty.header')))]),_c('p',{class:_vm.$style.text},[_vm._v(_vm._s(_vm.$t('checkout.basket.empty.text')))])])
}
var staticRenderFns = []

export { render, staticRenderFns }